<div class="form-group position-relative">
    <div class="search">
        <i class="fas fa-search search-icon"></i>
        <input [formControl]="myControl" [placeholder]="placeholder" type="text" placeholder="Search control point"
            class="form-control search-input mb-2 ml-8 mr-8" 
            (input)="onInputChange()" 
            (focus)="onInputFocus()" 
            (blur)="onInputBlur()" />
    </div>

    <ul *ngIf="isDropdownVisible && filteredOptions.length > 0"
        class="list-group position-absolute w-100 mt-0 dropdown-results"
        style="max-height: 200px; overflow-y: auto; z-index: 1000;">
        <li *ngFor="let option of filteredOptions" class="list-group-item list-group-item-action"
            (click)="selectOption(option)">
            {{ option.name }}
        </li>
    </ul>
</div>